'use client';

import { ReactNode } from 'react';
import { Hide, StackProps, VStack } from '@chakra-ui/react';
import { FooterLinks } from './FooterLinks';
import { useAppLayoutContext } from './AppLayoutContext';

export interface MainContainerProps extends StackProps {
  footer?: ReactNode;
}

export const MainContainer = (props: MainContainerProps) => {
  const { children, bg, color, footer, ...rest } = props;

  const { variant } = useAppLayoutContext();

  return (
    <VStack
      flex="1"
      w="full"
      align="center"
      gap="0.5rem"
      pt="1.5rem"
      borderBottomRadius="3xl"
      bg={variant === 'error' ? 'error.500' : bg}
      color={variant === 'error' ? 'white' : color}
      maxW={[
        'max-giftcards-pages-main-sm',
        'max-giftcards-pages-main-sm',
        'max-giftcards-pages-main-lg',
      ]}
      {...rest}
    >
      {children}

      <Hide above="md" ssr>
        {footer || (
          <FooterLinks
            mt="1.875rem"
            maxW={[
              'max-giftcards-pages-main-sm',
              'max-giftcards-pages-main-sm',
              'max-giftcards-pages-main-lg',
            ]}
          />
        )}
      </Hide>
    </VStack>
  );
};
